import { defineComponent, computed } from "vue";
import generalDialog from 'src/components/general/dialog.vue';
export default defineComponent({
    name: "validate",
    components: {
        generalDialog
    },
    props: {
        show: Boolean,
        email: String,
    },
    emits: ["update:show"],
    setup(props, context) {
        const showDialog = computed({
            get: () => props.show,
            set: () => context.emit("update:show"),
        });
        return { showDialog };
    },
});
